import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { RosterStore } from "@app/services/store/roster/roster-store";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import moment from "moment";
import { Roster } from "@app/models/rest/roster/roster";
import { DateField } from "@bryntum/core-thin";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-roster-list",
  templateUrl: "./roster-list.component.html",
  styleUrls: ["./roster-list.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class RosterListComponent
  extends BaseDataTablePageDirective<Roster>
  implements OnInit
{
  rosterStore: RosterStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected clientConfig = inject(ClientConfigService);
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      field: "name",
      text: "Name",
      flex: 1,
      editor: true
    },
    {
      field: "startDate",
      text: "Start Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: new DateField({
        format: "DD/MM/YYYY",
        keepTime: "12:00"
      })
    },
    {
      field: "endDate",
      text: "End Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    },
    {
      field: "length",
      text: "Length",
      flex: 1,
      type: "number",
      editor: true
    },
    {
      field: "generateDaysAhead",
      text: "Generate Days",
      flex: 1,
      type: "number",
      editor: true,
      max:
        this.clientConfig.config.maxPlanningWindow !== 0
          ? this.clientConfig.config.maxPlanningWindow
          : null
    },
    {
      type: "action",
      text: "Edit",
      width: 50,
      actions: [
        {
          cls: "fa fa-pencil",
          tooltip: "Edit Roster",
          onClick: ({ record }) => {
            console.log(`Editing ${record.name}`);
            console.log(this.router);
            if (isNaN(record.id)) {
              console.log("unsaved");
              this.serverErrorHandler.handleClientError(
                "Save changes before editing this record"
              );
              return;
            }
            this.router
              .navigate(["setup/resourcing/rosters", record.id])
              .then();
          }
        }
      ]
    }
    // {
    //   field: 'scoreWeight',
    //   text: 'Score Weight',
    //   flex: 1,
    //   editor: true,
    //   type: 'number'
    // }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const rosterStore = inject(RosterStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      rosterStore,
      store,
      dialog,
      "Roster",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.rosterStore = rosterStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      name: "",
      startDate: moment().toDate(),
      endDate: null,
      length: 7,
      generateDaysAhead: 14
    });
  }
}
